'use client';
import BrandLogo from '@/views/commonComponent/brand/BrandLogo';
import { useState, useEffect } from 'react';
import type { FormInstance } from 'antd';
import { Button, Checkbox, Form, Input } from 'antd';
import { Container, Row, Col } from 'react-bootstrap';
import { emailPattern } from '../../../utils/FormValidations';
import Link from 'next/link';
import '../style.scss';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../../../fire-base/FirebaseAuth';
import { useRouter } from 'next/navigation';

const ResetButton = ({ form }: { form: FormInstance }) => {
  const [submittable, setSubmittable] = useState(false);

  // Watch all values
  const values = Form.useWatch([], form);

  useEffect(() => {
    form.validateFields({ validateOnly: true }).then(
      () => {
        setSubmittable(true);
      },
      () => {
        setSubmittable(false);
      }
    );
  }, [values]);

  return (
    <Button className="primaryButton" type="primary" htmlType="submit" disabled={!submittable}>
      Reset Password
    </Button>
  );
};

const ForgotPassword = () => {
  const [form] = Form.useForm();
  const router = useRouter();

  const onFinish = async (values: any) => {
    try {
      await sendPasswordResetEmail(auth, values?.email);
      router.push(`/auth/email-on-the-way?email=${values?.email}`);
    } catch (exp) {
      window.alert(exp);
    }
  };

  const onFinishFailed = (errorInfo: any) => {};

  return (
    <div className="auth-main-div">
      <Container fluid>
        <Row>
          <Col xs={12} md={6}>
            <div className="authLeftside">
              <BrandLogo size="sm" href="/" className="loginLogo" />
              <div className="forgot-password-form">
                <h5 className="loginHeading">Forgot Password?</h5>
                <p className="loginSubHeading">
                  Enter your account’s email address and we will
                  <br /> send you a link to reset your password.
                </p>
                <Form
                  name="basic"
                  initialValues={{ remember: true }}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  autoComplete="off"
                  layout="vertical"
                  form={form}
                >
                  <Form.Item
                    name="email"
                    label="Email Address"
                    rules={[
                      {
                        required: true,
                        pattern: emailPattern.value,
                        message: emailPattern.message,
                      },
                    ]}
                  >
                    <Input placeholder="Enter email address" />
                  </Form.Item>
                  <Form.Item>
                    <ResetButton form={form} />
                  </Form.Item>
                </Form>
                <div className="back-to-login mt-4">
                  <p>
                    Back to <Link href="/auth/login">Login</Link>
                  </p>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} className="authBgImage">
            <div className="authRightside">
              <div className="contentPart">
                <p>
                  “Efficient and professional. I will definitely use their services again. <br />
                  The professionalism of this team made the entire process effortless and
                  stress-free.”
                </p>
                <h5>Darrell Steward</h5>
                <h6>Founder & CEO</h6>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default ForgotPassword;
